import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { captureLabel } from "./capture-label";

export function describeAnnotateImage(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  return captureLabel(
    {
      optionFailed: "Failed to annotate an option image",
      optionRunning: "Annotating an option image",
      optionDone: "Annotated an option image",
      failed: () => "Failed to annotate an image",
      running: () => "Annotating an image",
      done: () => "Annotated an image",
    },
    state,
    { isOption: record.silent === true, subject: null },
  );
}
